const events = {
  CITY_SELECTED: 'citySelector_city_selected',
  OPEN: 'citySelector_open',
};

export default events;



// WEBPACK FOOTER //
// ./resources/assets/js/components/citySelector/events.js